import { logSearchEvent } from 'api/search'

const eventData = new Map<string, object>()
const eventStarts = new Map<string, number>()
const eventEnds = new Map<string, number>()

export function startTracking(event: string, data: any): boolean {
  let isNewStart = false

  // if data is different, reset the start time
  if (eventData.get(event) !== data) {
    eventData.set(event, data)
    eventStarts.set(event, Date.now())
    isNewStart = true
  }

  // remove the end time if it exists
  // which means the component is remounted quickly,
  // so we will keep tracking the event
  if (eventEnds.has(event)) {
    eventEnds.delete(event)
    isNewStart = true
  }

  return isNewStart
}

export function endTracking(event: string) {
  eventEnds.set(event, Date.now())

  // delay a little bit before sending the event
  // as the loading component might be unmounted and remounted quickly
  // we want to make sure the event is not sent if the component is remounted
  setTimeout(() => {
    const data = eventData.get(event)
    const startTime = eventStarts.get(event)
    const endTime = eventEnds.get(event)
    if (data && startTime && endTime) {
      resetTracking(event)
      logSearchEvent({
        event,
        duration: endTime - startTime,
        data,
      })
    }
  }, 200)
}

function resetTracking(event: string) {
  eventData.delete(event)
  eventStarts.delete(event)
  eventEnds.delete(event)
}
